import React, { Suspense, lazy } from 'react'
import { RouteObject } from 'react-router-dom'


import BaseLayout from './layout/BaseLayout'
import HomeLayout from './layout/HomeLayout'
import SuspenseLoader from './components/SuspenseLoader'
import AppsLayout from './layout/AppsLayout'
import AuthLayout from './layout/AuthLayout'
import AccountLayout from './layout/AccountLayout'

// eslint-disable-next-line func-names
const Loader = (Component: any) => function(props: any) {
    return <Suspense fallback={<SuspenseLoader />}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Component {...props} />
    </Suspense>
};


const Home = Loader(lazy(() => import('./components/Home')))

// Applications
const PkiApp = Loader(lazy(() => import('./page/Apps/Pki')))
const IdentityApp = Loader(lazy(() => import('./page/Apps/Identity')))

// Authentication
const Login = Loader(lazy(() => import('./page/Auth/Login')))
const Otp = Loader(lazy(() => import('./page/Auth/Otp')))

// Account
const AccountPage = Loader(lazy(() => import('./page/Account')))
const CreateAccount = Loader(lazy(() => import('./page/Account/Create')))
const RecoverAccount = Loader(lazy(() => import('./page/Account/Recover')))
const BackupAccount = Loader(lazy(() => import('./page/Account/Backup')))

const WalletConnect = Loader(lazy(() => import('./page/WalletConnect')))
const Support = Loader(lazy(() => import('./page/Support')))
const Profile = Loader(lazy(() => import('./page/Profile')))


const routes: RouteObject[] = [
    {
        path: '',
        element: <BaseLayout />,
        children: [
            {
                path: '',
                element: <HomeLayout />,
                children: [
                    {
                        path: '',
                        element: <Home />,
                    },
                    {
                        path: 'apps',
                        element: <AppsLayout />,
                        children: [
                            {
                                path: 'pki',
                                element: <PkiApp />
                            },
                            {
                                path: 'identity/:trackingCode',
                                element: <IdentityApp />
                            }
                        ]
                    }
                ]
            },
            {
                path: 'auth',
                element: <AuthLayout />,
                children: [
                    {
                        path: 'login',
                        element: <Login />
                    },
                    {
                        path: 'otp',
                        element: <Otp />
                    }
                ]
            },
            {
                path: 'account',
                element: <AccountLayout />,
                children: [
                    {
                        path: '',
                        element: <AccountPage />
                    },
                    {
                        path: 'create',
                        element: <CreateAccount />,
                    },
                    {
                        path: 'recover',
                        element: <RecoverAccount />
                    },
                    {
                        path: 'backup',
                        element: <BackupAccount />
                    }
                ]
            },
            {
                path: 'walletConnect',
                element: <WalletConnect />
            },
            {
                path: 'support',
                element: <Support />
            },
            {
                path: 'profile',
                element: <Profile />
            }
        ]
    }
]


export default routes;
